<template>
  <thead class="grey lighten-4">
    <tr>
      <th class="pa-0" style="width: 10px;"></th>
      <th
        v-for="field in fieldList"
        :key="field.code"
        class="text-left text-body-2 text--secondary font-weight-medium pe-0 py-3 ps-1"
      >
        <div class="d-flex flex-column flex-md-row align-center">
          <span>{{ field.title }}</span>
          <div>
            <v-btn x-small icon @click="onSort(field)">
              <v-icon>mdi-sort-alphabetical-ascending</v-icon>
            </v-btn>
            <v-btn x-small icon @click="onFilter(field)">
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </div>
        </div>
      </th>
      <th class="text-left text-body-2 text--secondary font-weight-medium py-2 px-2" style="min-width: 120px">
        {{ $t("Actions") }}
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
    name: 'DocumentTableHeader',
    props: {
        fieldList: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        onFilter(field) {
            this.$emit('on-table-filter', field.title);
        },
        onSort(field) {
            this.$emit('on-table-sort', field);
        }
    }
};
</script>